import { EventType, EventTypeDetailed, GeoLocation, SortValue } from "@/types";

import { axios } from "../axios.instance";

export type FilterAffairsOptions = {
  location?: GeoLocation;
  fromDate?: string;
  toDate?: string;
  sortBy?: SortValue;
};

export type GetAffairesRequest = {
  perPage?: number;
  cursor?: string;
} & FilterAffairsOptions;

export type GetAffairesResponse = {
  data: Array<EventType & EventTypeDetailed>;
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const GetAffaires = async ({ location, ...params }: GetAffairesRequest): Promise<GetAffairesResponse> => {
  const { data } = await axios.get(
    `/events/affairs${location ? `?location=${location.coordinates[1]},${location.coordinates[0]}` : ""}`,
    {
      params,
    }
  );

  return data;
};
